/* sv-gallery-follow.js (store 0.46.8): the product photos follow what is being built, on every personalised product.

   Tony, 25 Sep 2026, on a product with a new design picked and the gallery still on the sample: "go through every custom
   product and ensure it changes the view on the product to the graphic selected ok i have asked this before".

   Your Design or Ours pages do this in sv-anyart.js. This file covers the rest:
     - one-design products (sacks, stockings, mugs, towels, ornaments, bandanas): once a name is typed or the
       customer's own image is uploaded, the first photo shows the "as it will be printed" preview (the design or the
       upload, with the name above or under it). Picking another design already opens that design's page (sv-swatch.js).
     - garments: sv-garment.js already draws the garment in its colour with the name; an upload is shown here.
     - photo blankets: once a photo is chosen, the first photo shows the blanket preview from sv-photo.js.
   "See product photo" puts the photo back until the next change. */
(function () {
  if (window.__svGalFollow) return; window.__svGalFollow = true;

  function boot() {
    if (document.querySelector('[data-sv-anyart]')) return;          /* sv-anyart.js does its own */
    if (!document.querySelector('media-gallery')) return;
    if (!document.querySelector('.sv-preview2__stage, [data-photo-canvas]')) return;

    var css = document.createElement('style');
    css.textContent = '.sv-gf{position:absolute;inset:0;z-index:4;background:#F7F5F0;border-radius:inherit;overflow:hidden}' +
      '.sv-gf[hidden]{display:none}.sv-gf__in{position:absolute;left:50%;top:50%;transform-origin:50% 50%}' +
      '.sv-gf__in>canvas{display:block;max-width:none!important;max-height:none!important}.sv-gf .sv-preview2__stage{margin:0!important}' +
      '.sv-gf__tag{position:absolute;left:10px;top:10px;z-index:2;background:#0E2B22;color:#F4EEE2;font-size:12px;font-weight:700;line-height:1;padding:7px 10px;border-radius:999px}' +
      '.sv-gf__x{position:absolute;right:10px;bottom:10px;z-index:2;min-height:36px;padding:0 12px;border:1px solid #0E2B22;background:#fff;color:#0E2B22;font:inherit;font-size:13px;font-weight:600;border-radius:999px;cursor:pointer}';
    document.head.appendChild(css);

    var off = false, lastKey = '';
    function hosts() {
      return Array.prototype.slice.call(document.querySelectorAll('media-gallery slideshow-slides > .product-media-container:first-child, media-gallery .media-gallery__grid > .product-media-container:first-child, media-gallery .dialog-zoomed-gallery > .product-media-container:first-child')).map(function (c) {
        return c.querySelector('.product-media') || c;
      });
    }
    function firstStage() {
      var all = document.querySelectorAll('.sv-preview2__stage');
      for (var i = 0; i < all.length; i++) if (all[i].getBoundingClientRect().width > 0) return all[i];
      return all[0] || null;
    }
    function nameTyped() {
      var n = document.querySelector('.sv-name');
      return n && String(n.value || '').trim();
    }
    /* what to show, or null to leave the product photo */
    function source() {
      var pc = document.querySelector('[data-photo-canvas]'), pf = document.getElementById('sv-photo-file');
      if (pc && pf && pf.files && pf.files.length) return { canvas: pc, key: 'photo:' + pf.files[0].name + ':' + (nameTyped() || '') };
      var stage = firstStage(); if (!stage) return null;
      var art = stage.querySelector('.sv-preview2__art');
      var src = art ? (art.currentSrc || art.src || '') : '';
      var up = /^(blob|data):/.test(src);
      var nm = nameTyped();
      if (!up && !nm) return null;
      if (!up && document.querySelector('media-gallery canvas.sv-gcv')) return null;   /* the garment drawing already shows it */
      return { stage: stage, key: src + '|' + nm + '|' + stage.innerHTML.length };
    }
    function render() {
      var s = source();
      var key = s ? s.key : '';
      if (key !== lastKey) { off = false; lastKey = key; }
      hosts().forEach(function (h) {
        var ov = h.querySelector('.sv-gf');
        if (!s || off) { if (ov) ov.hidden = true; return; }
        if (!ov) {
          ov = document.createElement('div'); ov.className = 'sv-gf';
          ov.innerHTML = '<div class="sv-gf__in"></div><span class="sv-gf__tag">Your design</span><button type="button" class="sv-gf__x">See product photo</button>';
          if (getComputedStyle(h).position === 'static') h.style.position = 'relative';
          ov.addEventListener('click', function (e) { e.stopPropagation(); if (!e.target.closest('.sv-gf__x')) e.preventDefault(); }, true);
          ov.querySelector('.sv-gf__x').addEventListener('click', function (e) { e.preventDefault(); off = true; render(); });
          h.appendChild(ov);
        }
        ov.hidden = false;
        var box = ov.querySelector('.sv-gf__in'), W = ov.clientWidth, H = ov.clientHeight, w, hh;
        box.innerHTML = '';
        if (s.canvas) {
          var c = document.createElement('canvas'); c.width = s.canvas.width; c.height = s.canvas.height;
          c.getContext('2d').drawImage(s.canvas, 0, 0);
          w = s.canvas.width; hh = s.canvas.height;   /* its own pixel shape; its on-page box can be squeezed */
          c.style.width = w + 'px'; c.style.height = hh + 'px';
          box.appendChild(c);
        } else {
          /* drawn large from the preview's own parts: its artwork (ours or the upload), and the name in the preview's
             face, colour and keylines, above or under the art as the product prints it */
          var art = s.stage.querySelector('.sv-preview2__art'), nmEl = s.stage.querySelector('.sv-preview2__name');
          var above = s.stage.getAttribute('data-slot') === 'above', txt = nmEl ? nmEl.textContent.trim() : '';
          var cs = nmEl ? getComputedStyle(nmEl) : null;
          w = W || 400; hh = H || 400;
          var wrap = document.createElement('div');
          wrap.style.cssText = 'width:' + w + 'px;height:' + hh + 'px;box-sizing:border-box;padding:44px 0 52px;display:flex;flex-direction:' + (above ? 'column-reverse' : 'column') + ';align-items:center;justify-content:center;gap:' + Math.round(hh * 0.02) + 'px';
          if (art) { var im = document.createElement('img'); im.src = art.currentSrc || art.src; im.alt = ''; im.style.cssText = 'display:block;max-width:' + Math.round(w * 0.86) + 'px;max-height:' + Math.round((hh - 96) * (txt ? 0.74 : 1)) + 'px;width:auto;height:auto;object-fit:contain'; wrap.appendChild(im); }
          if (txt && cs) {
            var t = document.createElement('div'); t.textContent = txt;
            var fs = Math.round(Math.min(hh * 0.12, 64));
            t.style.cssText = 'white-space:nowrap;line-height:1.1;font-family:' + cs.fontFamily + ';color:' + cs.color + ';text-shadow:' + (cs.textShadow === 'none' ? '' : cs.textShadow) + ';font-size:' + fs + 'px;text-transform:' + cs.textTransform + ';font-weight:' + cs.fontWeight;
            wrap.appendChild(t);
            box.appendChild(wrap);
            /* the preview's keylines are sized for its small face; scale them with the bigger one */
            var small = parseFloat(cs.fontSize) || 29, ratio = fs / small;
            if (cs.textShadow && cs.textShadow !== 'none') t.style.textShadow = cs.textShadow.replace(/(-?\d*\.?\d+)px/g, function (m, v) { return (parseFloat(v) * ratio).toFixed(2) + 'px'; });
            while (t.scrollWidth > w * 0.9 && fs > 10) { fs -= 2; t.style.fontSize = fs + 'px'; }
          } else box.appendChild(wrap);
          w = w; hh = hh;
        }
        if (!W || !H) { box.style.transform = 'translate(-50%,-50%)'; return; }
        var k = s.canvas ? Math.min(W * 0.9 / w, H * 0.9 / hh) : 1;
        box.style.transform = 'translate(-50%,-50%) scale(' + k + ')';
      });
    }
    var pend = false;
    function soon() { if (pend) return; pend = true; setTimeout(function () { pend = false; try { render(); } catch (e) {} }, 120); }
    document.addEventListener('input', soon, true);
    document.addEventListener('change', soon, true);
    document.addEventListener('click', function (e) { if (e.target && e.target.closest && !e.target.closest('.sv-gf')) soon(); }, true);
    window.addEventListener('resize', soon);
    var mo = new MutationObserver(function (list) {
      for (var i = 0; i < list.length; i++) { var t = list[i].target; if (t && t.closest && t.closest('.sv-gf')) continue; soon(); return; }
    });
    mo.observe(document.querySelector('main') || document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['src', 'style'], characterData: true });
    soon();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
